import { AuthGuard } from './core/auth.guard';
import { AuthService } from './core/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule, MatPaginatorModule } from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';

import { AngularFireModule } from 'angularfire2';
// for AngularFireDatabase
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireDatabase } from 'angularfire2/database';
// for AngularFireAuth
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireAuth } from 'angularfire2/auth';

import { ItemService } from './services/item.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Daterangepicker } from 'ng2-daterangepicker';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';






import { AppComponent } from './app.component';
import { NavComponent } from './nav/nav.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { AdvertisersComponent } from './advertisers/advertisers.component';
import { CategoriesComponent } from './categories/categories.component';
import { IndustryComponent } from './industry/industry.component';
import { BrandsComponent } from './advertisers/brands/brands.component';
import { ChannelsComponent } from './advertisers/channels/channels.component';
import { PositionsComponent } from './advertisers/positions/positions.component';
import { SlotsComponent } from './advertisers/slots/slots.component';
import { RoundPipe, ArraySortPipe } from './pipes/round.pipe';
import { ChartComponent } from './chart/chart.component';
import { LoadingSpinnerComponent } from './ui/loading-spinner/loading-spinner.component';
import { LocationStrategy, HashLocationStrategy, TitleCasePipe } from '@angular/common';
import { PubAdvertisersComponent } from './publishers/pub-advertisers/pub-advertisers.component';
import { PubCategoriesComponent } from './publishers/pub-categories/pub-categories.component';
import { CreateClientComponent } from './auth/client/create-client/create-client.component';
import { EditClientComponent } from './auth/client/edit-client/edit-client.component';
import { ListClientComponent } from './auth/client/list-client/list-client.component';
import { CreateUserComponent } from './auth/create-user/create-user.component';
import { EditUserComponent } from './auth/edit-user/edit-user.component';
import { UserInfoComponent } from './auth/user-info/user-info.component';
import { UserLoginComponent } from './auth/user-login/user-login.component';
import { ShortNumberPipe } from './pipes/short-number.pipe';
import { BrandAuditRequestComponent } from './brand-audit-request/brand-audit-request.component';
import { BrandAuditListComponent } from './brand-audit-list/brand-audit-list.component';
import { BrandAuditViewComponent } from './brand-audit-view/brand-audit-view.component';
import { QueryFormComponent } from './query-form/query-form.component';
import { ActivityDashboardComponent } from './activity/activity-dashboard/activity-dashboard.component';
import { MissingReportComponent } from './publishers/missing-report/missing-report.component';
import { TopAdvertisersComponent } from './publishers/top-advertisers/top-advertisers.component';
import { CompetitionTimebandComponent } from './publishers/competition-timeband/competition-timeband.component';
import { WeeklyChartComponent } from './publishers/weekly-chart/weekly-chart.component';




@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    FooterComponent,
    HomeComponent,
    AdvertisersComponent,
    CategoriesComponent,
    IndustryComponent,
    BrandsComponent,
    ChannelsComponent,
    PositionsComponent,
    SlotsComponent,
    RoundPipe,
    ArraySortPipe,
    ChartComponent,
    LoadingSpinnerComponent,
    PubAdvertisersComponent,
    PubCategoriesComponent,
    CreateClientComponent,
    EditClientComponent,
    ListClientComponent,
    CreateUserComponent,
    EditUserComponent,
    UserInfoComponent,
    UserLoginComponent,
    ShortNumberPipe,
    BrandAuditRequestComponent,
    BrandAuditListComponent,
    BrandAuditViewComponent,
    QueryFormComponent,
    ActivityDashboardComponent,
    MissingReportComponent,
    TopAdvertisersComponent,
    CompetitionTimebandComponent,
    WeeklyChartComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    Daterangepicker,
    
    // BsDatepickerModule.forRoot(),
    RouterModule.forRoot([
      // { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
      // { path: '', component: HomeComponent },
      { path: 'login', component: UserLoginComponent },
      // { path: 'home', component: HomeComponent },
      { path: 'advertisers', component: AdvertisersComponent },
      { path: 'advertisers/brands', component: BrandsComponent },
      { path: 'advertisers/channels', component: ChannelsComponent },
      { path: 'advertisers/positions', component: PositionsComponent },
      { path: 'advertisers/slots', component: SlotsComponent },
      { path: 'advertisers/categories', component: CategoriesComponent },
      // Publishers Section
      { path: 'publishers/categories', component: PubCategoriesComponent },
      { path: 'publishers/advertisers', component: PubAdvertisersComponent },
      { path: 'publishers/missing-report', component: MissingReportComponent },
      { path: 'publishers/top-advertisers', component: TopAdvertisersComponent },
      { path: 'publishers/competition-timeband', component: CompetitionTimebandComponent },
      { path: 'publishers/weekly-chart', component: WeeklyChartComponent },

      // User Access //
      { path: 'users/list', component: UserInfoComponent },
      { path: 'users/create', component: CreateUserComponent },
      { path: 'client/create', component: CreateClientComponent },
      { path: 'client/list', component: ListClientComponent },
      { path: 'client/edit/:id', component: EditClientComponent },
      { path: 'user/edit/:id', component: EditUserComponent },
      { path: 'brand-audit/request', component: BrandAuditRequestComponent },
      { path: 'brand-audit/list', component: BrandAuditListComponent },
      { path: 'brand-audit/view/:id', component: BrandAuditViewComponent },
      { path: 'queries', component: QueryFormComponent },
      // { path: 'queries', component: BrandAuditRequestComponent },

      // User Activty
      { path: 'activity/dashboard', component: ActivityDashboardComponent },
      
    ]),
 

  ],
  providers: [AuthService,AuthGuard, ItemService, { provide: LocationStrategy, useClass: HashLocationStrategy }, TitleCasePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts